import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import { HEADER_ID } from 'constant'

const HeaderDesktop = ({ placeholders: { headerContentBlock = []} = {}, ...props }) =>
  <Media.Desktop>
    <Placeholder />
    <HeaderDesktopContainer id={ HEADER_ID }>
      { headerContentBlock }
    </HeaderDesktopContainer>
  </Media.Desktop>


HeaderDesktop.propTypes = {
  '@type': PropTypes.string,
  'endeca:auditInfo': PropTypes.shape({
    'ecr:innerPath': PropTypes.any,
    'ecr:resourcePath': PropTypes.string
  }),
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    headerContentBlock: PropTypes.array
  })
}

HeaderDesktop.type = 'HeaderDesktop'
HeaderDesktop.placeholders = ['headerContentBlock']

export default HeaderDesktop

const HeaderDesktopContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000; /* @TODO */
  background: ${Theme.colors.veil};
`

const Placeholder = styled.div`
  height: 110px;
`
